var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-search-browse",
    {
      attrs: {
        "data-source": _vm.dataSource,
        multiple: _vm.multiple,
        "override-static-view-select": _vm.overrideStaticViewSelect,
        view: _vm.view,
      },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
        "select-changed": function ($event) {
          return _vm.onSelectChanged($event)
        },
      },
    },
    [
      _vm._t(
        "browse-action-buttons",
        function () {
          return [
            _vm.multiple
              ? _c(
                  "div",
                  [
                    _c(
                      "w-button",
                      {
                        staticClass: "ml",
                        attrs: { icon: "check", disabled: _vm.buttonDisabled },
                        on: {
                          click: function ($event) {
                            return _vm.onMultiple($event)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        { slot: "browse-action-buttons" }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }